"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogList = getLogList;
exports.getOperationList = getOperationList;
var _request = _interopRequireDefault(require("@/utils/request"));
function getLogList(params) {
  return (0, _request.default)({
    url: '/api/v1/common/log',
    method: 'get',
    params: params
  });
}
function getOperationList() {
  return (0, _request.default)({
    url: '/api/v1/system/select_list/operation_type',
    method: 'get'
  });
}